export default "__VITE_ASSET__BNewDzsb__"